<template>
  <div>
    <ShotStyle ref="ShotTextArea"> </ShotStyle>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :next-input="nextKey"
      :show-gesture="true"
      :input="input"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import ShotStyle from "../../StyleText/ShotStyle";
export default {
  name: "ShortcutsStep",
  components: {
    ShotStyle,
    SimpleKeyboard,
  },
  data() {
    return {
      input: "",
      nextKey: "",
    };
  },
  created() {
    this.$nextTick(() => {
      this.nextKey = this.$refs.ShotTextArea.nextKey();
    });
  },
  mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);
      if (btn === false) {
        return true;
      }
      this.$refs.ShotTextArea.handlerWord(btn);
      var ch = this.$refs.ShotTextArea.nextWord();
      this.nextKey = this.$refs.ShotTextArea.nextKey();
      return ch === btn;
    };
  },
  methods: {
    onChange(input) {
      this.input = input;
      console.log(input, "input");
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
  },
};
</script>

<style lang="less" scoped></style>
